export const extractVideoId = (
  url: string,
): null | { id: string; embedType: "video" | "playlist" } => {
  const videoMatch = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/.exec(url);
  const playlistMatch = /[?&]list=([^#&?]+)/.exec(url);

  const videoId = videoMatch ? (videoMatch[2]?.length === 11 ? videoMatch[2] : null) : null;
  const playlistId = playlistMatch ? playlistMatch[1] : null;

  let id = videoId !== null ? videoId : playlistId !== null ? playlistId : "";

  if (id?.length !== 0)
    return {
      id,
      embedType: videoId ? "video" : "playlist",
    };

  return null;
};
